import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { WorkerSynchronizerSpawner } from './worker-synchronizer-spawner';
import { WorkerSynchronizerSpawnerBrowser } from './worker-synchronizer-spawner-browser';

export function provideWorkerSynchronizerSpawnerBrowser(): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: WorkerSynchronizerSpawner, useClass: WorkerSynchronizerSpawnerBrowser }]);
}
